import { CardType } from '../../type';
import styles from './card.module.css';

interface CardProps {
  dataCard: CardType;
}

const CardDesktop: React.FC<CardProps> = ({ dataCard }) => {
  const { cardItems, isActionHandling, nameAsset, numberAsset } = dataCard;

  return (
    <div className={styles.card}>
      <div className={styles.cardCommonInfo}>
        <div className={styles.commonInfoDesc}>
          <div className={styles.descTitle}>{nameAsset}</div>
          <div>Asset No. {numberAsset}</div>
        </div>
      </div>
      {cardItems.map((item) => (
        <div key={`${item.label}+${item.value}`} className={styles.cardInfo}>
          <div className={styles.cardInfoTitle}>{item.label}</div>
          <div>{item.value}</div>
        </div>
      ))}
      {isActionHandling && <div> Asset Handle </div>}
    </div>
  );
};

export default CardDesktop;
